import { CheckCircleOutLine, LoaderBars } from '@/client/components/icons/ContinuIcons';
import { HStack, Icon, Text } from '@chakra-ui/react';

import { useAdminAssignmentsStore } from '../../state/adminAssignmentsStore';
import { useTranslation } from 'react-i18next';

interface AssignmentBuilderPreviewStatusProps {
  form: 'generalDetails' | 'automations' | 'audience' | 'content' | 'settings' | 'notifications';
}

export default function AssignmentBuilderPreviewStatus({
  form,
}: AssignmentBuilderPreviewStatusProps) {
  const { t } = useTranslation();
  const { previewStatusMap } = useAdminAssignmentsStore();

  const statusMap = {
    completed: {
      label: t('admin.assignments.status.completed'),
      icon: CheckCircleOutLine,
      style: {
        backgroundColor: '#DDF8E5',
        borderColor: '#C2F5CE',
        color: '#2CBE75',
      },
    },
    inProgress: {
      label: t('admin.assignments.status.inProgress'),
      icon: LoaderBars,
      style: {
        backgroundColor: 'warmNeutral.100',
        borderColor: 'warmNeutral.200',
        color: 'warmNeutral.900',
      },
    },
    notStarted: {
      label: t('admin.assignments.status.notStarted'),
      icon: undefined,
      style: {
        backgroundColor: 'neutral.0',
        borderColor: 'neutral.100',
        color: 'neutral.600',
      },
    },
  };

  return (
    <HStack
      sx={{
        ...statusMap[previewStatusMap[form]].style,
        opacity: 0,
        animation: '0.3s ease-in-out forwards fadeIn',
      }}
      border="1.5px solid"
      borderRadius="12px"
      paddingY={1}
      paddingX={4}
      css={{
        '@keyframes fadeIn': {
          '0%': { opacity: 0 },
          '100%': { opacity: 1 },
        },
      }}
    >
      {statusMap[previewStatusMap[form]].icon && (
        <Icon
          as={statusMap[previewStatusMap[form]].icon}
          sx={{
            opacity: 0,
            animation: '0.3s ease-in-out forwards fadeIn',
          }}
        />
      )}

      <Text
        fontSize="14px"
        fontWeight={500}
        sx={{
          opacity: 0,
          animation: '0.3s ease-in-out forwards fadeIn',
        }}
      >
        {statusMap[previewStatusMap[form]].label}
      </Text>
    </HStack>
  );
}
